import { DataList } from '@modules/charts/components/DataList';
import { CircularLoader } from '@modules/common/components/CircularLoader';
import { Widgets } from '@modules/common/constants';
import { ChartWidgetErrorMessage } from '@modules/feed/components/ChartWidgetErrorMessage';
import { NoDataFound } from '@modules/feed/components/NoDataFound';
import { ShowInQuantifyButton } from '@modules/feed/components/ShowInQuantifyButton';
import {
  useFetchTrendingReasons,
  useSearchAnalysesWhereClause,
} from '@modules/feed/hooks';
import { SearchActionType } from '@modules/feed/store/searchActionType';
import { useSearchStore } from '@modules/feed/store/searchStore';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { TimeRange } from 'v2/core/entities';
import { FieldNames } from 'v2/core/entities/fields';

export function TrendingReasonsWidget() {
  const { reasons, error, refetch, loading } = useFetchTrendingReasons();

  const duration = useSearchStore(({ query }) => query.duration);
  const dispatch = useSearchStore(({ dispatch }) => dispatch);
  const whereClause = useSearchAnalysesWhereClause();

  useEffect(() => {
    dispatch({
      type: SearchActionType.SET_ARE_WIDGETS_LOADING,
      payload: {
        trendingReasonsWidget: loading,
      },
    });

    return () => {
      dispatch({
        type: SearchActionType.SET_ARE_WIDGETS_LOADING,
        payload: {
          trendingReasonsWidget: false,
        },
      });
    };
  }, [dispatch, loading]);

  const renderTrendingReasonsWidget = () => {
    if (error) {
      return (
        <ChartWidgetErrorMessage
          onDataRefresh={() => {
            refetch?.();
          }}
        />
      );
    }

    if (loading) {
      return <CircularLoader />;
    }

    if (reasons.length === 0) {
      return <NoDataFound title="No Reasons found for your query." />;
    }

    return (
      <DataList
        baseWhereClause={whereClause}
        data={reasons}
        fieldName={FieldNames.Reason}
        dateRange={duration as TimeRange}
        onFeedbackDrawerClose={() => refetch?.()}
        shouldHideOpenInSearchOnFeedbackDrawer
      />
    );
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        borderRadius: 2,
        height: '100%',
      }}
    >
      <Stack direction="column">
        <Stack direction="row" justifyContent="space-between" p={2}>
          <Typography variant="h6">Trending Reasons</Typography>
          {reasons?.length > 0 && (
            <ShowInQuantifyButton widget={Widgets.Reason} />
          )}
        </Stack>
        <Box sx={{ height: 300 }}>{renderTrendingReasonsWidget()}</Box>
      </Stack>
    </Paper>
  );
}
